import { render } from "./multiple-radios.vue?vue&type=template&id=0b7c7641"
import script from "./multiple-radios.vue?vue&type=script&lang=js"
export * from "./multiple-radios.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/horizontal/multiple-radios.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b7c7641"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b7c7641', __exports__)) {
    console.log('reload')
    api.reload('0b7c7641', __exports__)
  }
  
  module.hot.accept("./multiple-radios.vue?vue&type=template&id=0b7c7641", () => {
    console.log('re-render')
    api.rerender('0b7c7641', render)
  })

}


export default __exports__